import { Component } from '@theme/component';
import { mediaQueryLarge } from '@theme/utilities';
import { openSizePicker } from '@theme/size-picker';

/**
 * Quick-add on product cards. Multi-variant products open the compact size picker.
 */
export class QuickAddComponent extends Component {
  connectedCallback() {
    super.connectedCallback();

    mediaQueryLarge.addEventListener('change', this.#noop);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    mediaQueryLarge.removeEventListener('change', this.#noop);
  }

  #noop = () => {};

  get productPageUrl() {
    return /** @type {HTMLAnchorElement} */ (
      this.closest('product-card')?.querySelector('a[ref="productCardLink"]')
    )?.href;
  }

  /**
   * Handles quick add button click for multi-variant products.
   * @param {Event} event - The click event
   */
  handleClick = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    const productUrl = this.productPageUrl || this.dataset.productUrl;
    if (!productUrl) return;

    try {
      await openSizePicker({
        productUrl,
        mode: 'add',
      });
    } catch (error) {
      if (error instanceof DOMException && error.name === 'AbortError') return;
      console.error(error);
    }
  };
}

if (!customElements.get('quick-add-component')) {
  customElements.define('quick-add-component', QuickAddComponent);
}
